import FieldReferenceIdAndKeyDto from "../../../dtos/FieldReferenceIdAndKeyDto";
import DataTableReadDto from "../../../dtos/pathcommonmodule/DataTableReadDto";

class PathDataTableDetailsResult {
    DataTable: DataTableReadDto;
    Fields: FieldReferenceIdAndKeyDto[];

    constructor(dataTable: DataTableReadDto, fields: FieldReferenceIdAndKeyDto[]) {
        this.DataTable = dataTable;
        this.Fields = fields;
    }
}

export default PathDataTableDetailsResult;
